import { Box, Container, Heading, Image, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { motion } from 'framer-motion';
import Footer from './Footer';
const MotionHeading = motion(Heading);

export const MaintenanceGuard = ({ children }) => {
  return children;
  // const router = useRouter();

  // const { override } = router.query;
  // if (
  //   process.env.NODE_ENV === 'production' &&
  //   new Date().getTime() < 1641020400000 &&
  //   override !== 'true'
  // ) {
  //   return (
  //     <Box bgColor="whiteAlpha.100">
  //       <Container p="4" pb={8} maxW="container.xl" centerContent>
  //         <Image src="/assets/songADAYLogo.png" alt="SongADao Logo" h="28" loading="eager" />
  //         <Heading
  //           as="h1"
  //           fontSize="5xl"
  //           fontWeight="regular"
  //           letterSpacing="tight"
  //           textAlign="center"
  //           my={6}
  //         >
  //           We're preparing to mint!
  //         </Heading>
  //         <Heading letterSpacing="widest" fontWeight="semibold" mt={3} fontSize="2xl">
  //           SEE YOU ON
  //         </Heading>
  //         <MotionHeading
  //           fontSize={{ base: '6xl', md: '8xl' }}
  //           textAlign="center"
  //           animate={{ y: [28, -8, 0], opacity: 1 }}
  //           initial={{ opacity: 0 }}
  //           transition={{ delay: 0.6 }}
  //           color="brand.teal"
  //         >
  //           DEC. 31, 2021
  //         </MotionHeading>
  //         <Text letterSpacing="widest" fontSize="3xl" mt={2}>
  //           — NOON EST —
  //         </Text>
  //         <Image src="/assets/maintainence-2.png" alt="SpaceMann" h={64} loading="eager" mt={12} />
  //       </Container>
  //       <Footer />
  //     </Box>
  //   );
  // }

  // return children;
};
